// Exact-site matching for the Geography highlight toggles. Two kinds,
// mutually exclusive (one active highlight at a time — the state slot
// holds a single match object):
//   einzellage — Anbaugebiet, Bereich, Ort AND Einzellage match exactly
//   grosslage  — Anbaugebiet, Bereich AND Großlage match exactly (no Ort)
// Empty matches empty; no other fields participate.

const norm = (v) => {
  if (v == null) return null;
  const s = String(v).trim();
  return s === '' ? null : s;
};

export const MATCH_KINDS = {
  einzellage: ['anbaugebiet', 'bereich', 'ort', 'einzellage'],
  grosslage: ['anbaugebiet', 'bereich', 'grosslage'],
};

export function siteMatchOf(row, kind) {
  const fields = MATCH_KINDS[kind];
  if (!fields) return null;
  const out = { kind };
  for (const f of fields) out[f] = norm(row?.[f]);
  return out;
}

export function sameSiteMatch(a, b) {
  if (!a || !b || a.kind !== b.kind) return false;
  const fields = MATCH_KINDS[a.kind];
  if (!fields) return false;
  return fields.every(f => norm(a[f]) === norm(b[f]));
}

// map-feature-properties variant: does this feature belong to the match?
export function matchesSite(props, match) {
  if (!match) return false;
  return sameSiteMatch(siteMatchOf(props, match.kind), match);
}

// GWS key vineyards (notable) auto-activate the Einzellage highlight on
// selection so the full site shows — but only when the vineyard IS the
// Einzellage (display name equals the Einzellage name; e.g. Pittersberg
// yes, "Im Pittersberg" no: a named sub-parcel shouldn't light up the
// whole site). Null einzellage never matches — it would sweep up every
// unnamed vineyard of the Ort. The returned match carries auto: true
// (ignored by the field comparators above): unlike a manually toggled
// highlight, an auto one does NOT survive onto a same-site vineyard
// that wouldn't itself earn it.
export function autoEinzellageMatch(row) {
  if (!row?.notable) return null;
  const einzellage = norm(row.einzellage);
  const name = norm(row.canonical_name_de) ?? norm(row.full_label_name) ?? norm(row.osm_name);
  if (einzellage == null || name == null) return null;
  if (name.toLowerCase() !== einzellage.toLowerCase()) return null;
  return { ...siteMatchOf(row, 'einzellage'), auto: true };
}
